import { api } from '@/lib/http-client';
import type {
  SaveWompiPayload,
  WompiAmbiente,
  WompiStatus,
  WompiTestResult,
} from '@/types/integrations';

/**
 * Módulo Wompi — pago en línea (docs/WOMPI.md), en la capa de API del frontend.
 *
 * Una función por endpoint, como en el resto de `src/api/`. Dos detalles del contrato que esta capa
 * tiene que respetar:
 *  - las llaves NUNCA se devuelven (solo máscaras + la pública), igual que las API keys;
 *  - `guardar` hace MERGE: mandar solo `{ activo: false }` apaga sin borrar las llaves, así que el
 *    admin nunca tiene que reescribirlas.
 */

/** `GET /api/tenants/:tenantId/wompi` — estado de la conexión (lo ve cualquier miembro). */
export function fetchWompiStatus(tenantId: string): Promise<WompiStatus> {
  return api.get<WompiStatus>(`/api/tenants/${tenantId}/wompi`);
}

/** `PUT /api/tenants/:tenantId/wompi` (solo ADMIN; guarda las llaves cifradas). */
export function saveWompiConfig(tenantId: string, payload: SaveWompiPayload): Promise<WompiStatus> {
  return api.put<WompiStatus>(`/api/tenants/${tenantId}/wompi`, payload);
}

/** `DELETE /api/tenants/:tenantId/wompi` (solo ADMIN) — desconecta y borra las llaves. */
export function removeWompiConfig(tenantId: string): Promise<{ eliminado: boolean }> {
  return api.delete<{ eliminado: boolean }>(`/api/tenants/${tenantId}/wompi`);
}

/**
 * `POST /api/tenants/:tenantId/wompi/test` (solo ADMIN). Sin payload usa las llaves guardadas;
 * con `{ llavePublica, ambiente }` prueba lo que el admin acaba de escribir, SIN guardar nada.
 */
export function testWompiConnection(
  tenantId: string,
  payload?: { llavePublica?: string; ambiente?: WompiAmbiente },
): Promise<WompiTestResult> {
  return api.post<WompiTestResult>(`/api/tenants/${tenantId}/wompi/test`, payload ?? {});
}